/**
 * TeamBoard — GEN-281: el tablero «columnas por departamento» del equipo, común
 * a «Tu equipo» (Home) y a «Mi equipo». Una columna por departamento, título
 * alineado abajo (subrejilla, GEN-191-T1) y tarjetas apiladas; el líder primero.
 * `overline` admite texto o un nodo (cabecera); `pie` es opcional (GEN-PX-010).
 * Solo pinta la estructura: cada pantalla aporta su tarjeta con `renderCard`.
 */

import { groupByDepartment } from '../lib/agent-groups.js'

export default function TeamBoard({ agents, ariaLabel, overline, renderCard, pie }) {
  const grupos = groupByDepartment(agents, { lideresPrimero: true })
  if (grupos.length === 0) return null
  return (
    <section className="home-team" aria-label={ariaLabel}>
      {typeof overline === 'string' && overline && <span className="home-team__overline">{overline}</span>}
      {overline && typeof overline !== 'string' && <div className="home-team__cab">{overline}</div>}
      {grupos.map(grupo => (
        <div className="home-dept" key={grupo.departamento}>
          <h2 className="home-dept__title">{grupo.departamento}</h2>
          <div className="home-dept__grid">
            {grupo.agents.map(renderCard)}
          </div>
        </div>
      ))}
      {pie && <div className="home-team__pie">{pie}</div>}
    </section>
  )
}
